import { FaExclamationTriangle } from "react-icons/fa";

export const ExclamationTriangle = ({ ...rest }) => {
  return <FaExclamationTriangle {...rest} />;
};
